import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Btn, Input, Spinner } from '../components/UI';

export default function ResetPassword() {
  const [searchParams]          = useSearchParams();
  const token                   = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [errors, setErrors]     = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone]         = useState(false);
  const [serverError, setServerError] = useState('');

  useEffect(() => {
    if (!token) setServerError('Invalid reset link. Please request a new one.');
  }, [token]);

  function validate() {
    const e = {};
    if (!password)            e.password = 'Password is required';
    else if (password.length < 8) e.password = 'Minimum 8 characters';
    if (password !== confirm) e.confirm = 'Passwords do not match';
    return e;
  }

  async function submit(e) {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length) return;

    setSubmitting(true);
    setServerError('');
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL || ''}/api/auth/reset-password`,
        { token, password }
      );
      setDone(true);
    } catch (err) {
      setServerError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: '24px',
    }}>
      <div style={{
        width: '100%', maxWidth: 420,
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r2)', padding: '36px 32px', boxShadow: '0 4px 24px #0001',
      }}>

        {/* Logo / title */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            background: 'var(--accent-light)', border: '1.5px solid var(--accent)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
          }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--accent2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <h1 style={{ fontFamily: 'var(--serif)', fontSize: 22, fontWeight: 700, marginBottom: 4 }}>
            Reset Password
          </h1>
          <p style={{ fontSize: 13, color: 'var(--text2)' }}>Sulthaniya Foundation</p>
        </div>

        {/* Success state */}
        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              background: 'var(--accent-light)', border: '1px solid #b7e4c7',
              borderRadius: 'var(--r)', padding: '16px', marginBottom: 20,
              fontSize: 14, color: 'var(--accent2)', lineHeight: 1.6,
            }}>
              ✓ Your password has been updated successfully.
            </div>
            <div style={{
              width: '100%', padding: '8px 16px', borderRadius: 'var(--r)',
              background: 'var(--accent)', color: '#fff',
              fontSize: 13, fontWeight: 500, textAlign: 'center',
              boxSizing: 'border-box',
            }}>
              Please login from the app
            </div>
          </div>
        ) : (
          <form onSubmit={submit} noValidate>

            {/* Invalid / missing token */}
            {serverError && (
              <div style={{
                background: 'var(--red-bg, #fff5f5)', border: '1px solid #f5c6c2',
                borderRadius: 'var(--r)', padding: '10px 14px',
                fontSize: 13, color: 'var(--red, #c0392b)', marginBottom: 18, lineHeight: 1.5,
              }}>
                {serverError}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <Input
                label="New password"
                type="password"
                placeholder="Minimum 8 characters"
                value={password}
                onChange={e => { setPassword(e.target.value); setErrors(v => ({ ...v, password: '' })); }}
                error={errors.password}
                disabled={!token}
              />
              <Input
                label="Confirm new password"
                type="password"
                placeholder="Repeat password"
                value={confirm}
                onChange={e => { setConfirm(e.target.value); setErrors(v => ({ ...v, confirm: '' })); }}
                error={errors.confirm}
                disabled={!token}
              />
            </div>

            <div style={{ marginTop: 22 }}>
              <Btn
                type="submit"
                disabled={submitting || !token}
                style={{ width: '100%', justifyContent: 'center' }}
              >
                {submitting ? <Spinner size={15} color="#fff" /> : 'Set new password'}
              </Btn>
            </div>

          </form>
        )}
      </div>
    </div>
  );
}
